export const fetchThreadsGeneric = async ({
  dispatch,
  getThreadsAction,
  agentType,
  sessionStorageKey,
  sessionManager,
  navigate,
  isMobile,
  hasAccess,
}) => {
  // If user doesn't have access, skip fetching threads.
  // Navigation/redirect is handled by the route guard (AuthGaurd) and the
  // AccessDeniedModal, so we should NOT navigate from here.
  if (!hasAccess()) {
    return [];
  }

  const params = {};

  if (!["GMT", "PROCUREMENT_AI"].includes(agentType)) {
    params.delete_flag = false;
  }

  try {
    const response = await dispatch(getThreadsAction(params));

    if (response?.total_sessions === 0) {
      sessionManager.setSessionId(null, sessionStorageKey);
    }

    return (
      response?.threads ||
      response?.sessions ||
      (Array.isArray(response) ? response : [])
    );
  } catch (error) {
    console.error("Error fetching threads:", error);
    return [];
  }
};
